import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SousBienService } from 'app/services/sousBiens/sous-bien.service';

@Component({
  selector: 'app-liste-sous-meilleurs-biens',
  templateUrl: './liste-sous-meilleurs-biens.component.html',
  styleUrls: ['./liste-sous-meilleurs-biens.component.scss']
})
export class ListeSousMeilleursBiensComponent implements OnInit {

  dataSource = new MatTableDataSource();
  public search: string  = ''

  sousBiens : any
  constructor(private sousBienService:SousBienService) { }

  getData() {
    this.sousBienService.getListSousMeilleursBien().subscribe((data) => {
      this.sousBiens = data;
    });
  }
  ngOnInit() {
    this.sousBienService.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }

  deletesousBien(sousBien: any) {
    this.sousBienService.deleteSousBien(sousBien.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
    setTimeout(() => {
      this.getData()
    }, 500)

  }


  
}
